export type MembershipTier = 'outer_circle' | 'inner_circle';

export const getMembershipUrl = (tier: MembershipTier, target: string): string =>
  `/membership?tier=${tier}&target=${encodeURIComponent(target)}`;
